import moment from 'moment'

export default async function saveNode({ state, graphql }) {
  let { name, path, id, fromDate, toDate, tags } = state.get('node.panel')
  const groups = Object.keys(tags).reduce((acc, key) => {
    const tag = tags[key]
    if (tag.selected) {
      acc.push(`"${tag.label}"`)
    }
    return acc
  }, [])

  const parentId = id ? `"${id}"` : null

  if (fromDate) {
    fromDate = moment(fromDate).valueOf()
  } else {
    fromDate = null
  }

  if (toDate) {
    toDate = moment(toDate)
      .endOf('day')
      .valueOf()
  } else {
    toDate = null
  }

  const result = await graphql.mutate(`{
      addNode(parent: ${parentId}, name: "${name.value.trim()}", groups: [${groups.join()}], fromDate: ${fromDate}, toDate: ${toDate}) {
        id
      }
    }`)

  let fullPath = `node.nodes.${result.addNode.id}`
  if (path) {
    fullPath = `${path}.nodes.${result.addNode.id}`
    state.set(`${path}.hasNodes`, true)
  }
  state.set(`${fullPath}`, {
    id: result.addNode.id,
    name: name.value.trim(),
    hasNodes: false,
    nodes: {}
  })
}



// WEBPACK FOOTER //
// ./src/modules/Node/actions/saveNode.js